import React, {Component, PropTypes} from 'react';
import DatePicker from 'react-datepicker';
import styled from 'styled-components';
import {
  Col,
  Button,
  FormGroup,
  InputGroup,
} from '@sketchpixy/rubix';
import {
  getPaymentDetail,
  updateBillingDate,
  updateInstallmentAmount,
  updateInstallmentPeriod
} from '../../../api/api';
import NumberFormat from "react-number-format";
import moment from "moment";
import ContractStatus from "../../../constants/ContractStatus";
import EditCardModal from "../Modal/EditCardModal";

const Root = styled(Col)`
  padding: 0;
`;


const Container = styled.div`
  display: flex;
  flex-flow: column;
  border-bottom: ${props => props.expand ? '2px' : '1px'} solid #d8d8d8;

`;

const Title = styled.div`
  height: 65px;
  font-weight: bold;
  color: black;
  display: flex;
  align-items: center;
  font-size: 18px;
`;

const Item = styled.div`
  display: flex;
  min-height: 60px;
  text-align: justify;
   
  &:last-child {
    border-bottom: 0;
  }
  
  & div:first-child {
    color: black;
  }
  
  & div {
    margin-top: auto;
    margin-bottom: auto;
    padding: 0;
  }
`;

const ItemTitle = styled.div`
  width: 202px;
  font-size: 16px;
`;

const BlueAmount = styled.div`
  width: 120px;
  color: blue;
  font-weight: bold;
`;


const RedAmount = styled.div`
  width: 120px;
  color: red;
  font-weight: bold;
`;


class PaymentInfo extends Component {
  constructor(props) {
    super(props);

    let opportunityLink = props.contract.opportunityLink ? props.contract.opportunityLink : '';
    this.state = {
      installmentAmount: {
        formattedValue: '',
        value: null,
      },
      installmentPeriod: {
        formattedValue: '',
        value: null,
      },
      payment: {},
      payPeriod: 1,
      opportunityLink: opportunityLink,
      showEditCardModal: false
    };
  }


  componentDidMount() {
    this.getPaymentDetail(this.props.contract.contractId);
  }

  componentWillReceiveProps(nextProps) {
    this.getPaymentDetail(nextProps.contract.contractId);
  }


  displayAmount = (amount) => {
    const scientificNotation = Math.pow(10, this.props.decimalScale * -1);
    return (amount * scientificNotation).toFixed(2);
  };


  billingDateChangeHandler = (nextPaymentDate) => {
    this.setState({
      nextPaymentDate: nextPaymentDate.getTime()
    });
  };

  getExpectedPaymentDate = () => {
    return this.state.nextPaymentDate;
  };


  opportunityLinkChangeHandler = (event) => {
    this.setState({
      opportunityLink: event.target.value
    });
  };

  installmentAmountChangeHandler = (values) => {
    let installmentAmount = this.state.installmentAmount;

    const {formattedValue, value} = values;

    installmentAmount.formattedValue = formattedValue;
    installmentAmount.value = value * 100;

    this.setState({
      installmentAmount
    });
  };

  installmentPeriodChangeHandler = (values) => {
    let installmentPeriod = this.state.installmentPeriod;

    const {formattedValue, value} = values;

    installmentPeriod.formattedValue = formattedValue;
    installmentPeriod.value = value;

    this.setState({
      installmentPeriod
    });
  };

  saveInstallmentPeriod = () => {
    let self = this;
    updateInstallmentPeriod({
      contractId: this.props.contract.contractId,
      period: this.state.installmentPeriod.value
    }, (err, result) => {
      if (err) {
        Messenger().post({
          type: 'error',
          message: `${err.message} (${err.statusCode})`,
          showCloseButton: true,
        });
      } else {
        self.props.paymentUpdated()
        Messenger().post({
          type: 'success',
          message: 'Billing Date updated successfully!',
          showCloseButton: true,
        });
      }
    });
  };

  saveInstallmentAmount = () => {
    let self = this;
    updateInstallmentAmount({
      contractId: this.props.contract.contractId,
      hardwareAmount: this.state.installmentAmount.value
      }, (err, result) => {
      if (err) {
        Messenger().post({
          type: 'error',
          message: `${err.message} (${err.statusCode})`,
          showCloseButton: true,
        });
      } else {
        self.props.paymentUpdated()
        Messenger().post({
          type: 'success',
          message: 'Billing Date updated successfully!',
          showCloseButton: true,
        });
      }
    });
  };

  updateBillingDate = () => {
    let paymentDate = this.getExpectedPaymentDate()
    if (!paymentDate )
    {
      alert("Please Input next Payment Date!");
      return;
    }

    let nextPaymentDate = moment(paymentDate ).format('YYYY-MM-DD');

    let self = this;
    updateBillingDate(this.props.contract.contractId, nextPaymentDate, (err, result) => {
      if (err) {
        Messenger().post({
          type: 'error',
          message: `${err.message} (${err.statusCode})`,
          showCloseButton: true,
        });
      } else {
        Messenger().post({
          type: 'success',
          message: 'Billing Date updated successfully!',
          showCloseButton: true,
        });
        self.props.paymentUpdated()
      }
    });
  };

  editCardButtonClickHandler = () => {
    this.setState({
      showEditCardModal: true,
    });
  };

  closeEditCardModal = (event) => {
    this.setState({
      showEditCardModal: false,
    });
  };


  getPaymentDetail(contractId) {
    getPaymentDetail(contractId, (err, result) => {
      if (err) {
        Messenger().post({
          type: 'error',
          message: `${err.message} (${err.statusCode})`,
          showCloseButton: true,
        });
      } else {
        const payment = result.detail;
        let installmentAmount = {
          value: this.props.contract.contractHardwareAmount,
          formattedValue: this.displayAmount(this.props.contract.contractHardwareAmount)
        }

        let installmentPeriod = {
          value: this.props.contract.installmentPeriod,
          formattedValue: this.props.contract.installmentPeriod
        }
        this.setState({
          payment,
          installmentPeriod,
          installmentAmount,
          nextPaymentDate: payment.nextPaymentDate
        });

      }
    });
  }


  render() {
    let numberInputFormatProps = {
      className: 'form-control',
      thousandSeparator: true,
      fixedDecimalScale: true,
      allowNegative: false,
    };
    let amountInputFormatProps = {
      className: 'form-control',
      thousandSeparator: true,
      decimalScale: 2,
      fixedDecimalScale: true,
      allowNegative: false,
    };

    return (
        <Root xs={12}>
          <Title>Payment Info</Title>
          <Container>
            <Item>
              <ItemTitle>Installment Period</ItemTitle>
              <FormGroup>
                <InputGroup>
                  <NumberFormat
                      {...numberInputFormatProps}
                      value={this.state.installmentPeriod.formattedValue}
                      onValueChange={(values) => this.installmentPeriodChangeHandler(values)}
                  />
                  <InputGroup.Button>
                    <Button bsStyle='red' onClick={this.saveInstallmentPeriod}>Save</Button>
                  </InputGroup.Button>
                </InputGroup>
              </FormGroup>
            </Item>
            <Item>
              <ItemTitle>Installment Amount</ItemTitle>
              <FormGroup>
                <InputGroup>
                  <InputGroup.Addon>{this.props.contract.currencyString}</InputGroup.Addon>
                  <NumberFormat
                      {...amountInputFormatProps}
                      value={this.state.installmentAmount.formattedValue}
                      onValueChange={(values) => this.installmentAmountChangeHandler(values)}
                  />
                  <InputGroup.Button>
                    <Button bsStyle='red' onClick={this.saveInstallmentAmount}>Save</Button>
                  </InputGroup.Button>
                </InputGroup>
              </FormGroup>
            </Item>
            <Item>
              <ItemTitle># of Installment Paid</ItemTitle>
              <NumberFormat
                  displayType="text"
                  thousandSeparator
                  prefix={`${this.props.currency} `}
                  decimalScale={this.props.decimalScale}
                  fixedDecimalScale
                  value={this.displayAmount(this.state.payment.installmentPaidAmount)}
                  renderText={value => <BlueAmount>{this.state.payment.installmentPaidCount}({value})</BlueAmount>}
              />
            </Item>
            <Item>
              <ItemTitle>Remaining Installment</ItemTitle>
              <NumberFormat
                  displayType="text"
                  thousandSeparator
                  prefix={`${this.props.currency} `}
                  decimalScale={this.props.decimalScale}
                  fixedDecimalScale
                  value={this.displayAmount(this.state.payment.remainInstallmentAmount)}
                  renderText={value => <RedAmount>{this.state.payment.remainInstallmentPeriod}({value})</RedAmount>}
              />
            </Item>
            <Item>
              <ItemTitle>One-Time Fee</ItemTitle>
              <NumberFormat
                  displayType="text"
                  thousandSeparator
                  prefix={`${this.props.currency} `}
                  decimalScale={this.props.decimalScale}
                  fixedDecimalScale
                  value={this.displayAmount(this.state.payment.onetimeAmount)}
                  renderText={value => <BlueAmount>{value}</BlueAmount>}
              />
            </Item>
            {
              this.props.contract.contractPgBillingKey &&
              <Item>
                <ItemTitle>Next Billing Date</ItemTitle>
                <div>
                  <FormGroup>
                    <InputGroup>
                      <DatePicker
                          selected={this.getExpectedPaymentDate()}
                          onChange={(date) => this.billingDateChangeHandler(date)}
                          withPortal
                          peekNextMonth
                          showMonthDropdown
                          showYearDropdown
                          dropdownMode="select"/>
                      {
                        this.props.contract.contractStatus === ContractStatus.ACTIVE.name &&
                        <InputGroup.Button>
                          <Button bsStyle='red' onClick={this.updateBillingDate}>Save</Button>
                        </InputGroup.Button>
                      }
                    </InputGroup>
                  </FormGroup>
                </div>
              </Item>
            }
            <Item>
              <ItemTitle>Payment Method</ItemTitle>
              <FormGroup>
                <InputGroup>
                    <InputGroup.Button>
                      <Button bsStyle='red' onClick={this.editCardButtonClickHandler}>Change Card</Button>
                    </InputGroup.Button>
                </InputGroup>
              </FormGroup>
            </Item>
          </Container>
          <EditCardModal
              contract={this.props.contract}
              showModal={this.state.showEditCardModal}
              closeModal={this.closeEditCardModal}
          />
        </Root>
    );
  }
}

PaymentInfo.propTypes = {
  paymentUpdated: PropTypes.func.isRequired,
  contract: PropTypes.shape({
    contractId: PropTypes.number,
    currencyName: PropTypes.string,
    currencyCode: PropTypes.string,
    currencyString: PropTypes.string,
    contractSalesRepEmail: PropTypes.string,
    contractPatientEmail: PropTypes.string,
    contractPgType: PropTypes.string,
    contractPgBillingKey: PropTypes.string,
    contractDevicesDetail: PropTypes.string,
    contractBillingDate: PropTypes.number,
    nextPaymentDate: PropTypes.string,
    contractStatus: PropTypes.string,
    installmentPeriod: PropTypes.number,
    contractOnetimeAmount: PropTypes.number,
    contractHardwareAmount: PropTypes.number,
    contractPostalCode: PropTypes.string,
    contractTaxRate: PropTypes.number,
    patientSubscription: PropTypes.object,
    payments: PropTypes.array,
    schedule: PropTypes.object,
    opportunityLink: PropTypes.string,
    createdTime: PropTypes.number,
    updatedTime: PropTypes.number,
  }).isRequired,
};


export default PaymentInfo;



// WEBPACK FOOTER //
// ./src/routes/patient/PaymentInfo/PaymentInfo.js